import styled from '@themes/theme'
import { keyframes } from '@emotion/core'
import { btnInitializationStyle, TxtLimit, TxtLimit2 } from '@styles/base.style'

export const PopularSearchTermRollingAni = keyframes`
    0% {
      opacity: 0;
      transform: translateY(10%);
    }
    8%, 96% {
      opacity: 1;
      transform: translateY(1.5px);
    }
    100% {
      opacity: 0;
      transform: translateY(-8%);
    }
`

export const PopularSearchTermH = '48px'

export const PopularSearchTermWrap = styled.div`
  z-index: 4;
  position: relative;
  width: 100%;
  height: ${PopularSearchTermH};
  .popular-search-panel-header {
    width: 100%;
    height: ${PopularSearchTermH};
    overflow: hidden;
    background: ${props => props.theme.color.mainColor};
    padding: 0 0 0 61px;
    line-height: 47px;
    color: ${props => props.theme.color.modalSubBg2};
    font-size: ${props => props.theme.font.title};
    font-weight: ${props => props.theme.fontW.bold};
    display: flex;
    align-items: center;
    .head-icon-txt {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(calc(-50% + 1px));
      z-index: 1;
      color: ${props => props.theme.color.handicap};
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.bold};
      text-transform: uppercase;
    }
    .popular-searches-btn {
      ${TxtLimit};
      text-align: left;
      font-size: ${props => props.theme.font.large};
      color: ${props => props.theme.color.modalSubBg2};
      width: calc(100% - 45px);
      border-radius: 0;
      &-num {
        margin: 0 10px 0 11px;
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.modalSubBg2};
      }
    }
    .arrow-btn {
      margin: 0 3px 1px auto;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      ${btnInitializationStyle};
      .arrow-ico {
        position: relative;
        display: block;
        width: 14px;
        height: 14px;
        transform: rotate(-45deg) translate(2px, -2px);
        &::before, &::after {
          content: '';
          display: block;
          position:absolute;
          bottom: 0;
          left: 0;
          background: ${props => props.theme.color.disableTxt2};
        }
        &::before {
          width: 12px;
          height: 2px;
        }
        &::after {
          width: 2px;
          height: 12px;
        }
        &.open {
          transform: rotate(135deg) translate(3px, -3px);
        }
      }
    }
  }
  .popular-searches-panel {
    position: absolute;
    top: ${PopularSearchTermH};
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 0;
    background: ${props => props.theme.color.mainColor};
    box-shadow: 0 3px 5px #00000029;
    opacity: 0;
    text-align: center;
    &-list {
      ${TxtLimit};
      width: calc(100% - 40px);
      height: 44px;
      background: ${props => props.theme.color.subColor};
      border-radius: 48px;
      text-align: left;
      padding: 0 19px;
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.modalSubBg2};
      margin: 0 auto 8px;
      &-num {
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.bold};
        color: ${props => props.theme.color.handicap};
        margin-right: 14px;
      }
      :nth-of-type(1) {
        margin-top: 8px;
      }
      :last-child {
        margin-bottom: 16px;
      }
    } 
    // 이슈 키워드 패널 열릴 때 스타일
    &.active {
      opacity: 1;
      max-height: 276px;
    }
  }
  // 이슈 키워드 패널 열렸을 때 스타일
  &.active {
    .popular-searches-btn {
      --rolling-second: 5s;
      animation: ${PopularSearchTermRollingAni} var(--rolling-second) infinite;
    }
  }
  // 실시간 인기 검색어 채팅창 스타일(MO)
  &.chatting {
    z-index: 0; // 응원글 패널과의 z-index 순서를 위해 추가한 코드
    &.is-open {
      z-index: 3; // 응원글 패널과의 z-index 순서를 위해 추가한 코드
    }
    .popular-search-panel-header {
      background: ${props => props.theme.color.modalSubBg2};
      color: ${props => props.theme.color.modalTxt};
      .head-icon-txt {
        color: ${props => props.theme.color.modalred};
      }
      .popular-searches-btn {
        color: ${props => props.theme.color.modalTxt};
        &-num {
          color: ${props => props.theme.color.modalTxt};
        }
      }
      .arrow-btn {
        .arrow-ico {
          &::before, &::after {
            background: ${props => props.theme.color.modalgray};
          }
        }
      }
    }
    .popular-searches-panel {
      background: ${props => props.theme.color.modalSubBg2};
      box-shadow: 0 3px 5px #00000014;
      &-list {
        background: #EEEEEEA6;
        color: ${props => props.theme.color.modalTxt};
        &-num {
          color: ${props => props.theme.color.modalred};
        }
      }
    }
  }
  &.pc {
    width: calc(100% + 30px);
    transform: translateX(-15px);
  }
`
export const PopularSearchTermPopupWrap = styled.div`
  background: ${props => props.theme.color.themeTxt};
  height: 100%;
  .am-list-header {
    .popup-title {
      display: block;
      padding: 26px 20px 0;
      margin-bottom: -10px;
    }
  }
  .am-list-body {
    background: ${props => props.theme.color.TP};
    padding: 0 20px;
  }
  .am-list-footer {
    max-width: 100vw;
    padding: 20px 20px 60px;
    // 추천분석글 프로필 카드 스타일 공통
    .quick-swipe {
      margin-block: 14px 0;
      padding: 0;
      > .swiper {
        margin-left: initial;
      } 
    }
    // 추천분석글 프로필 카드 스타일 pc
    .pc {
      max-width: 374px;
      .swiper-pagination {
        left: 0 !important;
        background: ${props => props.theme.color.modalBg};
      }
      .swiper-button-prev {
        left: 12px;
      }
      .swiper-button-next {
        left: 54px;
      }
      .swiper-button-prev.swiper-button-disabled , .swiper-button-next.swiper-button-disabled {
        opacity: 1;
      }
      .swiper-button-prev.swiper-button-disabled::before, .swiper-button-prev.swiper-button-disabled::after, .swiper-button-next.swiper-button-disabled::before, .swiper-button-next.swiper-button-disabled::after {
        background: ${props => props.theme.color.modalSubBg};
      }
      .swiper-button-prev::before, .swiper-button-prev::after, .swiper-button-next::before, .swiper-button-next::after {
        background: ${props => props.theme.color.modalgray};
      }
    }
  }
  .popup-title {
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.title};
    font-weight: ${props => props.theme.font.title};
  }

`
export const PopularSearchTermListWrap = styled.div`
  width: 100%;
  padding: 40px 20px 0;
  .popular-keyword {
    margin-bottom: 30px;
    &--txt {
      position: relative;
      margin-bottom: 10px;
      .txt-img {
        width: auto;
        height: 64px;
      }
      .keyword-num {
        position: absolute;
        bottom: 0;
        transform: translateY(3px);
        left: 67px;
        font-size: 26px;
        color: ${props => props.theme.color.modalred};
        text-shadow: -.5px 0 ${props => props.theme.color.modalred}, 0 .5px ${props => props.theme.color.modalred}, .5px 0 ${props => props.theme.color.modalred}, 0 -.5px ${props => props.theme.color.modalred};
      }
    }   
    &--contents {
      display: flex;
      width: 100%;
      min-height: 24px;
      line-height: 24px;
      border-radius: 22px;
      padding: 10px 20px;
      background: ${props => props.theme.color.whiteBg};
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.title};
    }
  }
  .list-title {
    margin-bottom: 14px;
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.largeNum};
    .news-txt {
      width: 137px;
      height: auto;
    }
  }
  .rsme-embed {
    width: 100%;
    max-width: calc(100vw - 40px);
    margin-bottom: 40px;
    iframe {
      width: 100% !important;
    }
    .youtube-iframe {
      iframe {
        border-radius: 16px;
        overflow: hidden;
      }
    }
  }
  &.pc {
    .rsme-embed {
      max-width: 354px;
    }  
  }
`
export const PopularSearchNewsListWrap = styled.div`
  .popular-search-news-btn {
    width: 100%;
    height: 87px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    border-radius: 12px;
    background: ${props => props.theme.color.white};
    box-shadow: 0 2px 4px #0000000F;
    padding: 0 16px;
    .title-box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .title {
        ${TxtLimit2};
        text-align: left;
        line-height: 19px;
        max-height: 45px;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.medium};
      }
      .date {
        width: 100%;
        text-align: left;
        margin-top: 4px;
        color: ${props => props.theme.color.modalDarkBg};
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.medium};
      }
    }
    &.clicked {
      .title {
        color: ${props => props.theme.color.modalDarkBg};
      }
      .date {
        color: ${props => props.theme.color.modalSubBg2};
      }
    }
  }
`
